<template>
  <div class="footer">
    <div class="contact">
      <div class="contact-item">
        <img src="../../../assets/images/tel.png" alt>
        <span>联系电话：{{ contact }}</span>
      </div>
      <div class="contact-item">
        <img src="../../../assets/images/email.png" alt>
        <span>QQ邮箱：{{ email }}</span>
      </div>
      <div class="contact-item">
        <img src="../../../assets/images/qq.png" alt>
        <span>联 系 QQ：{{ web_qq }}</span>
      </div>
      <div class="address">公司地址：{{ compony_address }}</div>
      <div class="icp">
        {{ copyright }} - <a :href="beian_website" target="_blank">{{ beian }}</a>
        <button v-if="privacy_policy" type="button" class="privacy-policy" @click="$router.push({ name: 'privacy_policy' })">
          &#38544;&#31169;&#25919;&#31574;
        </button>
      </div>
    </div>
    <div class="mini-app">
      <!-- <img :src="logo" alt> -->
       <div class="app">
        <div class="title">师傅接单</div>
       <img :src="appImage" alt="">
       </div >
       <div class="app">
          <div class="title">用户下单</div>
          <img :src="xcxImage" alt="">
       </div>

      <!-- <div class="title">艺棒小匠小程序</div> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      contact: '',
      copyright: '',
      describe: '',
      logo: '',
      name: '',
      version: '',
      beian: '',
      beian_website: '',
      compony_address: '',
      cooperation: '',
      email: '',
      phone: '',
      site_name: '',
      web_qq: '',
      wechat: '',
      privacy_policy: '',
      appImage: '',
      xcxImage: ''
    }
  },
  created () {
    // this.islogin = this.$store.state.hasLogin
    this.getInfo()
    this.getDownInfo()
  },
  methods: {
    getDownInfo () {
      this.$request('61cbbdb6af43a', {
        edition_number: '1'
      }).then(res => {
        this.appImage = res.data.data.edition.appDownload
        this.xcxImage = res.data.data.edition.wxDownload
      })
    },
    getInfo () {
      this.$request('635663a939a14').then(res => {
        let { contact,
          copyright,
          describe,
          logo,
          name,
          version,
          beian,
          beian_website,
          compony_address,
          cooperation,
          email,
          phone,
          site_name,
          web_qq,
           wechat,
           privacy_policy } = res.data.data
        this.contact = contact
        this.copyright = copyright
        this.describe = describe
        this.logo = logo
        this.name = name
        this.version = version
        this.beian = beian
        this.beian_website = beian_website
        this.compony_address = compony_address
        this.cooperation = cooperation
        this.email = email
        this.phone = phone
        this.site_name = site_name
        this.web_qq = web_qq
        this.wechat = wechat
        this.privacy_policy = privacy_policy
      })
    }
  }
}
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  min-width: 1200px;
  height: 150px;
  padding: 50px 100px;
  background-color: #252525;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .contact{
    display: flex;
    flex-wrap: wrap;
    .contact-item{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 30px;
      span{
        font-weight: 600;
        font-size: 12px;
        line-height: 17px;
        color: #ABABAC;
        margin-left: 8px;
      }
    }

    .address{
      width: 100%;
      font-weight: 600;
      font-size: 12px;
      line-height: 17px;
      color: #ABABAC;
      margin-top: 18px;
    }

    .icp{
      width: 100%;
      font-weight: 600;
      font-size: 12px;
      line-height: 17px;
      color: #ABABAC;
      margin-top: 18px;
    }

    .privacy-policy{
      width: auto;
      padding: 0;
      border: 0;
      background: transparent;
      text-align: left;
      font-weight: 600;
      font-size: 12px;
      line-height: 17px;
      color: #ABABAC;
      margin-left: 12px;
      cursor: pointer;
    }
  }
  .mini-app{

    // width: 120px;
    display: flex;
    align-items: center;
    .app{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
    }
  img{
    width: 100px;
    height: 100px;
    margin-left: 20px;
  }
    .title{
      font-size: 12px;
      line-height: 17px;
      color: #FFFFFF;
      // margin-left: 6px;
      margin-bottom: 5px;
    }
  }
}
</style>
